import { showErrorResponse } from "../../app/utils/common/Functions";
import {
  changePasswordAPI,
  getUserProfile,
  logIn,
  refreshTokenAPI,
  updateUserApi,
} from "../Apis/authApi";

export const authReducer = (builder) => {
  builder
    .addCase(logIn.pending, (state) => {
      state.auth.loading = true;
      state.auth.user = null;
    })
    .addCase(logIn.fulfilled, (state, action) => {
      state.auth.loading = false;
      state.auth.accessToken = action.payload.data.accessToken;
      state.auth.refreshToken = action.payload.data.refreshToken;
      localStorage.setItem("accessToken", action.payload.data.accessToken);
      localStorage.setItem("refreshToken", action.payload.data.refreshToken);
      state.auth.isAuth = true;
    })
    .addCase(logIn.rejected, (state, action) => {
      state.auth.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(getUserProfile.pending, (state) => {
      // Keep existing user while refetching — clearing it re-triggers
      // ProtectedRoute effects that depend on `user` and loops forever.
      // Only block the shell on the initial profile load.
      if (!state.auth.user) {
        state.auth.loading = true;
      }
    })
    .addCase(getUserProfile.fulfilled, (state, action) => {
      state.auth.loading = false;
      state.auth.error = null;
      state.auth.accessToken = localStorage.getItem("accessToken");
      state.auth.refreshToken = localStorage.getItem("refreshToken");
      state.auth.user = action.payload?.data?.profileData ?? null;
      state.auth.isAuth = Boolean(state.auth.user);
    })
    .addCase(getUserProfile.rejected, (state, action) => {
      state.auth.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(refreshTokenAPI.pending, (state) => {
      // state.auth = { ...state.auth, loading: true, error: null, user: null };
    })
    .addCase(refreshTokenAPI.fulfilled, (state, action) => {})
    .addCase(refreshTokenAPI.rejected, (state, action) => {
      state.auth.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(updateUserApi.pending, (state) => {
      state.auth.loading = true;
      // state.auth = { ...state.auth, loading: true, error: null, user: null };
    })
    .addCase(updateUserApi.fulfilled, (state, action) => {
      state.auth.loading = false;
      state.isUserUpdated = true;
      state.auth.user = { ...state.auth.user, ...action.payload.data };
    })
    .addCase(updateUserApi.rejected, (state, action) => {
      state.auth.loading = false;
      showErrorResponse(action.payload);
    })
    .addCase(changePasswordAPI.pending, (state) => {
      state.auth.loading = true;
    })
    .addCase(changePasswordAPI.fulfilled, (state) => {
      state.auth.loading = false;
    })
    .addCase(changePasswordAPI.rejected, (state, action) => {
      state.auth.loading = false;
      showErrorResponse(action.payload);
    });
};
